
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5124_6)"}},[_c('path',{attrs:{"d":"M15.542 15.542H4.458V6.834h11.084v8.708zm0-12.667h-.792V1.292h-1.583v1.583H6.833V1.292H5.25v1.583h-.792c-.878 0-1.583.713-1.583 1.584v11.083a1.584 1.584 0 001.583 1.583h11.084a1.584 1.584 0 001.583-1.583V4.459a1.583 1.583 0 00-1.583-1.584zm-1.956 6.381l-.839-.839-3.863 3.863-1.679-1.678-.839.84 2.518 2.517 4.702-4.703z","fill-opacity":".7"}}),_c('circle',{attrs:{"cx":"3.667","cy":"15.541","fill":"#fff","r":"3.958"}}),_c('path',{attrs:{"d":"M5.834 15.934h.1v-.867h-2v-2h-.867v2h-2v.867h2v2h.867v-2h1.9z","fill":"#188038","stroke":"#188038","stroke-width":".2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5124_6"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    